module.exports = __webpack_public_path__ + "img/food4.97ad97e1.png";